export const QA_NAME_DELETE_RESPONSIBLE_MANAGER_BTN = 'deleteResponsibleManager'
